export default "__VITE_ASSET__8732c0df__"